import type { ShortcutIcon } from "@/lib/dashboard-home/shortcuts";
import {
  BookOpen,
  Bookmark,
  Camera,
  Download,
  FilePlus,
  FileText,
  Film,
  Gavel,
  Globe,
  Landmark,
  Layers,
  Link2,
  type LucideIcon,
  Palette,
  PenLine,
  Pencil,
  Plus,
  Search,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Trash2,
  Upload,
  User,
  UserPlus,
} from "lucide-react";

/** Icônes des raccourcis (le catalogue, côté `lib`, ne connaît que leur nom). */
export const SHORTCUT_ICONS: Record<ShortcutIcon, LucideIcon> = {
  bookmark: Bookmark,
  search: Search,
  plus: Plus,
  pencil: Pencil,
  upload: Upload,
  download: Download,
  "file-text": FileText,
  "file-plus": FilePlus,
  trash: Trash2,
  globe: Globe,
  "shopping-cart": ShoppingCart,
  book: BookOpen,
  "user-plus": UserPlus,
  gavel: Gavel,
  layers: Layers,
  camera: Camera,
  film: Film,
  "pen-line": PenLine,
  "shield-check": ShieldCheck,
  settings: Settings,
  link: Link2,
  palette: Palette,
  user: User,
  landmark: Landmark,
};
